// Categories created before uploads existed may still carry an emoji glyph
// in iconUrl (free-form text column) — not a usable <img src>.
const isUsableIconUrl = url => typeof url === 'string' && url.startsWith('http');

/**
 * Icon resolution order for a category: its own icon, else its parent's,
 * else null (caller renders the NOW logo). Mirrors now-webadmin's
 * resolveCategoryIcon() in client/src/lib/categoryIcon.ts.
 *
 * @param {{ iconUrl?: string|null }} [category]
 * @param {{ iconUrl?: string|null }} [parent]
 * @returns {string|null}
 */
export const resolveCategoryIcon = (category, parent) => {
  if (isUsableIconUrl(category?.iconUrl)) return category.iconUrl;
  if (isUsableIconUrl(parent?.iconUrl)) return parent.iconUrl;
  return null;
};
